import React, { useState } from 'react';
import { MainService } from '../../_services';
import { Header } from '../../_components/shared/header';
import { useScanDetection } from '../../_hooks';
import { getTypeFirstScan } from '../../_utils/rcg/counter-identification';
import { ScannerRcg } from '../../_components/rcg/scanner-rcg';
import { RcgProductIdentification } from '../../_components/rcg/rcg-product-identification';
import { RcgProductActions } from '../../_components/rcg/rcg-product-actions';

const PANEL_SCANNER = 'scanner';
const PANEL_ACTIONS = 'actions';

const PANELS = [
    { key: PANEL_SCANNER, label: 'Scanner',  icon: 'fa-qrcode',      sectionTitle: 'Identification du matériel' },
    { key: PANEL_ACTIONS, label: 'Actions',  icon: 'fa-check-circle', sectionTitle: ' Traitement des matériels'  },
];

function PrestataireRcg() {
    const ms = new MainService();

    const [activePanel, setActivePanel]           = useState(PANEL_SCANNER);
    const [scanResult, setScanResult]             = useState(null);
    const [notFound, setNotFound]                 = useState(false);
    const [loading, setLoading]                   = useState(false);
    const [submitting, setSubmitting]             = useState(false);
    const [submitted, setSubmitted]               = useState(false);
    const [submitError, setSubmitError]           = useState(false);
    const [actionSubmitting, setActionSubmitting] = useState(false);
    const [actionSubmitted, setActionSubmitted]   = useState(false);
    const [actionSubmitError, setActionSubmitError] = useState(false);

    useScanDetection({
        onComplete: (code) => { if (!scanResult) handleScan(code); },
    });

    const handleScan = (barCode) => {
        if (!barCode) return;
        setLoading(true);
        setNotFound(false);
        ms.searchRcgProduct(barCode)
            .then((data) => {
                const { existsInRcg, product, manufacturer, productRcg } = data.data;
                setScanResult({ barCode, product, manufacturer, productRcg });
                const goToActions = existsInRcg && productRcg?.isCheckedByAgent === true && productRcg?.rcgAction?.label !== 'Traitement informatique en cours';
                setActivePanel(goToActions ? PANEL_ACTIONS : PANEL_SCANNER);
            })
            .catch(() => setNotFound(true))
            .finally(() => setLoading(false));
    };

    const handleSubmit = ({ isDamaged }) => {
        const payload = {
            barCode:        scanResult.barCode,
            productId:      scanResult.product.id,
            manufacturerId: scanResult.manufacturer.id,
            typeFirstScan:  getTypeFirstScan(isDamaged),
            isSagemcom:     false,
            isDamaged,
        };
        setSubmitting(true);
        setSubmitError(false);
        ms.createProductRcg(payload)
            .then(() => setSubmitted(true))
            .catch(() => setSubmitError(true))
            .finally(() => setSubmitting(false));
    };

    const handleActionSubmit = (payload) => {
        setActionSubmitting(true);
        setActionSubmitError(false);
        ms.patchRcgActions(scanResult.productRcg.id, payload)
            .then(() => setActionSubmitted(true))
            .catch(() => setActionSubmitError(true))
            .finally(() => setActionSubmitting(false));
    };

    const handleReset = () => {
        setScanResult(null);
        setSubmitted(false);
        setSubmitError(false);
        setActionSubmitted(false);
        setActionSubmitError(false);
        setNotFound(false);
        setActivePanel(PANEL_SCANNER);
    };

    const activeConfig = PANELS.find(p => p.key === activePanel);

    return (
        <>
            <Header />
            <div className={"page"}>


                <div className={"panel-section-title"}>
                    {activeConfig.sectionTitle}
                </div>

                {!scanResult
                    ? <ScannerRcg onSubmit={handleScan} notFound={notFound} loading={loading} />
                    : scanResult.productRcg?.isDamaged === true
                        ? (
                            <div>
                                <div className={"panel-card panel-card--warning"}>
                                    <p>🗑️ <b>Matériel à benner</b></p>
                                </div>
                                <div className={"btns"}>
                                    <button type={"button"} className={"btn btn-scan-other full"} onClick={handleReset}>
                                        <i className={"fa fa-qrcode"}></i> Scanner un autre matériel
                                    </button>
                                </div>
                            </div>
                          )
                    : (activePanel === PANEL_SCANNER && scanResult.productRcg && (!scanResult.productRcg.isCheckedByAgent || scanResult.productRcg?.rcgAction?.label === 'Traitement informatique en cours'))
                        ? (
                            <div>
                                <div className={"panel-card panel-card--warning"}>
                                    <p>
                                        <i className={"fa fa-exclamation-triangle"}></i>{' '}
                                        <b>Mettre de côté en attendant le retour informatique</b>
                                    </p>
                                </div>
                                <div className={"btns"}>
                                    <button type={"button"} className={"btn btn-scan-other full"} onClick={handleReset}>
                                        <i className={"fa fa-qrcode"}></i> Scanner un autre matériel
                                    </button>
                                </div>
                            </div>
                          )
                        : activePanel === PANEL_SCANNER
                            ? <RcgProductIdentification
                                scanResult={scanResult}
                                submitted={submitted}
                                submitting={submitting}
                                submitError={submitError}
                                onSubmit={handleSubmit}
                                onReset={handleReset}
                              />
                            : <RcgProductActions
                                scanResult={scanResult}
                                submitting={actionSubmitting}
                                submitted={actionSubmitted}
                                submitError={actionSubmitError}
                                onSubmit={handleActionSubmit}
                                onReset={handleReset}
                              />
                }
            </div>
        </>
    );
}

export { PrestataireRcg };
